import React from 'react';
import cs from 'classnames';

import sharedCSS from '~/components/shared.css';
import css from './index.css';

class Privacy extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          <h2>Privacy Policy</h2>
          <div className={cs(css.content)}>
            <h4>Last modified: April 9, 2019</h4>
            <p>
              Trucker Path collects information about you when you access and use our websites, mobile
              applications, content, products and services (collectively, the “Services”) and through other
              interactions and communications you have with us.  Our Services are provided by Trucker Path LLC,
              a Delaware limited liability company, located at 2828 N. Central Ave., Phoenix, AZ 85004 and its
              subsidiaries and affiliates (collectively, “Trucker Path”).  This Privacy Policy applies to
              information collected and used by Trucker Path unless any of its websites, mobile applications,
              content, products and services indicate they are subject to a separate privacy policy.
              In this Privacy Policy, the words “including” and “include” mean “including without limitation.”
            </p>
            <p>
              Protecting individual privacy is important to us.  This Privacy Policy is intended to notify you,
              or in the case that you represent a business entity, you and that business entity (“you”),
              of the type of information that we may collect from users of the Services and to generally
              summarize how we use and protect that information.  Please read this Privacy Policy carefully
              to understand our policies and practices regarding your information and how we will treat
              it.  BY ACCESSING AND USING THE SERVICES, YOU AGREE TO THIS PRIVACY POLICY.  IF YOU DO NOT
              AGREE TO THE TERMS AND CONDITIONS SET FORTH IN THIS PRIVACY POLICY, DO NOT ACCESS OR
              OTHERWISE USE THE SERVICES.
            </p>
            <h4>THE INFORMATION WE COLLECT</h4>
            <p>
              Information You Give Us
              <br/>
              We collect information you provide directly to us, including personally identifiable information
              you submit to complete a transaction or to receive information you have requested, such as by
              contacting us or registering to receive product announcements, updates and notifications,
              as well as content you submit in connection with your access and use of the Services.  This
              information may include your name, email address, mailing address and telephone number.  We
              may also collect financial information, including credit card numbers, associated card data
              and tax identification numbers, in the event you register an account and purchase Services
              from us.  Your payment information is collected and processed by a third-party vendor and
              is not stored or accessible by us.
            </p>
            <p>
              Information We Collect From Your Use of Our Services
              <br/>
              When you access and use our Services, we collection information about you that includes the
              following general categories:
            </p>
            <ol className={css.discListStyle}>
              <li>
                Usage and Preference Information: We collection information about how you interact with our
                Services, including the types of Services provided, time spent using the Services and other
                related transaction details. When you access the Services, we may use a web server log to
                automatically track and collect certain non-personally identifiable information, such as
                your Internet protocol (IP) address, referral pages and pages viewed, access times and
                other relevant statistics.  We also may use common information collection tools like pixel
                tags (also called beacons or clear gifs), which are small files installed on or called by
                a webpage or application, to retrieve certain information about your browser or device,
                including device type, operating system, browser type and version, website visited,
                time of visit, referring website, IP address and other similar information.  Another
                common identification technology we may use is cookies, which are small files placed
                on your computer’s hard drive or mobile device, to help recognize unique users and
                monitor general traffic and use trends.  Cookies help us to understand how you use
                and navigate our Services and, in turn, how we can make our Services more user friendly.
              </li>
              <li>
                Device Information: We may collect information from and about your mobile device,
                including the hardware model, operating system and version, software and file names and
                versions, preferred language, device identification number, serial number, device motion
                information, mobile network information, device’s telephone number, timestamp, location
                and stored cookies information.
              </li>
              <li>
                Log Information: When you interact with our Services, we collect server logs,
                which may include information like device IP address, access dates and times,
                application features or pages viewed, application crashes and other system activity,
                type of browser and the third party site or service you were using before interacting with our Services.
              </li>
              <li>
                Location Information: When you use our Services for load tracking, we collect precise
                location data about the trip from the application used by the driver. We may also
                derive your approximate location from your IP address.
              </li>
            </ol>
            <p>
              Third-Party Information Collection
              <br/>
              When you use our Services, certain third parties may use automatic information collection
              technologies to collect information about you or your device.  These third parties may
              include your mobile device manufacturer, your mobile network provider and analytics companies.
            </p>
            <p>
              The information these third parties collect may be associated with your personally
              identifiable information or they may collect information, including personally identifiable
              information, about your online activities over time and across different websites,
              applications and other online services websites.  We do not control these third parties’
              tracking technologies or how they may be used, and we are not responsible for their
              practices.  We encourage you to visit the third parties’ websites to learn more about
              their privacy policies.
            </p>
            <h4>HOW WE USE YOUR INFORMATION</h4>
            <p>
              The information we collect may be used to provide, maintain, protect, help improve, develop
              new functionality, administer and personalize our Services, provide product and service
              information, fulfill transactions or requests made by you and give you notices about your
              account and when application updates are available.  The information may also be used to carry
              out our obligations and enforce our rights arising from any contracts entered into between you
              and us, including for billing and collection, and for analytics, industry and market research
              and such other purposes consistent with our legitimate business needs.  Further, we may
              use certain information for the purpose stated at the time of your disclosure.
            </p>
            <p>
              Please note that we may share your personally identifiable information with third parties we
              use to support our business or with whom we have a business relationship and among each of
              our affiliated companies.  We may also disclose your personally identifiable information:
            </p>
            <ol className={css.romanListStyle}>
              <li>
                If we are required to do so by law or legal process (such as a court order);
              </li>
              <li>
                In response to a request by law enforcement authorities; or
              </li>
              <li>
                When we believe disclosure is necessary or appropriate to prevent physical harm or financial
                loss or in connection with an investigation of suspected or actual illegal activity.
              </li>
            </ol>
            <p>
              When you agree with another user of our Services to provide load tracking data to the other user,
              we will provide location information to the user during the applicable trip.  By agreeing to
              provide load tracking data to the other user, you expressly:
            </p>
            <ol className={css.romanListStyle}>
              <li>
                Agree to permit Trucker Path’s applications to access location services through the permission
                system used by your mobile operating system;
              </li>
              <li>
                Consent to Trucker Path’s use of location-based services, disclosure of your location data
                to the other user of Trucker Path’s Services with whom you agreed to provide load tracking
                data and disclosure of your location data for the reasons described above about how we may
                share your personally identifiable information with third parties; and
              </li>
              <li>
                Agree to defend, indemnify and hold us and our employees, contractors, officers and managers
                harmless from all liabilities, claims and expenses, including attorneys’ fees, arising out of
                or resulting from you disabling the collection of location information by changing the
                location settings on your mobile device.
              </li>
            </ol>
            <p>
              We do not rent, sell or trade any personally identifiable information and will not share your
              personally identifiable information with any third party except as set forth above.  However,
              we will from time to time contact you about our own or other companies’ goods and services that
              we think may be of interest to you.  We reserve the right to transfer your personally
              identifiable information in the event we sell, merge or transfer all or a portion of our
              equity, assets or business.
            </p>
            <p>
              We may disclose your non-personally identifiable information publicly or to third parties
              without restriction to, for example, show trends about the use of our Services, as we do
              not deem such information private or confidential.
            </p>
            <h4>YOUR CHOICES</h4>
            <p>
              Account Information
              <br/>
              You may correct your account information at any time by logging into your account.  If you wish
              to cancel your account, please contact us as set forth in this Privacy Policy.  Please note that
              in some cases we may retain certain information about you as required by law or for legitimate
              business purposes to the extent permitted by law.  For instance, if you have a standing credit
              or debt on your account, or if we believe you have committed fraud or violated our Terms
              and Conditions, we may seek to resolve the issue before deleting your information.
            </p>
            <p>
              Rights Concerning Your Personally Identifiable Information
              <br/>
              If you provide us with personally identifiable information, you have the following rights with
              respect to that personally identifiable information to:
            </p>
            <ol className={css.romanListStyle}>
              <li>
                Review the personally identifiable information that you have supplied to us;
              </li>
              <li>
                Request that we correct any errors, outdated information or omissions in the personally
                identifiable information that you have supplied to us;
              </li>
              <li>
                Request that your personally identifiable information not be used to contact you;
              </li>
              <li>
                Request that your personally identifiable information be removed from any solicitation list that we use;
              </li>
              <li>
                Request that your personally identifiable information be deleted from our records;
                and
              </li>
              <li>
                Opt out of being solicited by us.
              </li>
            </ol>
            <p>
              If you request that your personally identifiable information be deleted from our records,
              there may be a brief delay in our processing that request while we verify that the request is
              valid and originates from you as opposed to an unauthorized third party. If you request that
              your personally identifiable information be deleted, we reserve the right to terminate any
              account you have registered with us or limit your access to the Services.
            </p>
            <p>
              To exercise any of these rights, please contact us as set forth in this Privacy Policy.
            </p>
            <p>
              Location Information
              <br/>
              If you initially permit the collection of precise location from your mobile device per the
              permission system used by your mobile operating system, you can later disable it by changing
              the location settings on your mobile device.  This may limit your ability to use certain features
              of our Services.  Additionally, disabling the collection of precise location from your mobile
              device will not limit our ability to derive approximate location from your IP address.
            </p>
            <p>
              Cookies
              <br/>
              With most Internet browsers, you can erase or reject cookies, or set your browser to prompt a
              warning whenever a cookie is sent.  It may be possible to refuse to accept mobile cookies by
              activating the appropriate setting on your mobile device.  If you choose to refuse or remove
              cookies, this could affect the availability and functionality of our Services.
            </p>
            <h4>OPTING-OUT</h4>
            <p>
              If you have registered for product announcements, news or updates, we will use your
              personally identifiable information to fulfill your request.  You may stop receiving any
              electronic communications from us, including our newsletter, at any time by clicking on and
              completing the opt-out link provided at the bottom of the applicable email.
            </p>
            <h4>HOW WE PROTECT YOUR INFORMATION</h4>
            <p>
              The security of your personally identifiable information is important to us and we take
              reasonable precautions to protect it.  Information that is collected that is deemed to be
              confidential will be collected using secure socket layer (SSL) protocol, which encrypts data
              sent from your browser to our servers.  This data is then also encrypted in our databases,
              and only accessible by authorized staff within our organization.  Additionally, most Internet
              browsers also offer their own security features that enable end users to control how their
              transmissions are protected.  Please remember, however, that any personally identifiable
              information you send to us via the Internet is subject to the risk of unlawful interception
              by third parties, and that no method of safeguarding information is 100% secure.  Further,
              please note that, in our discretion, aggregated information that contains no personally
              identifiable information may not be treated as private or confidential.
            </p>
            <h4>CHILDREN UNDER THE AGE OF 13</h4>
            <p>
              The Services are not intended for use by children, and we do not knowingly collect personally
              identifiable information from children under the age of 13.  If you are under the age of majority
              in your place of residence, you may use the Services only with the consent of or under the
              supervision of your parent or legal guardian.  If we learn that we have received any
              information directly from a child under the age of 13 without first receiving his or her
              parent’s or legal guardian’s verified consent, we will use that information only to respond
              directly to that child (or his or her parent or legal guardian) to inform the child that he or
              she cannot use the Services and subsequently we will delete that information.  If you believe we
              might have any personally identifiable information from or about a child under the age of 13,
              please email us at (support email here).
            </p>
            <h4>AFFILIATED COMPANY WEBSITES</h4>
            <p>
              To the extent our Services contains links to any other websites operated by us, our partners
              or affiliates (each an “Affiliated Company Websites”), please check the individual Affiliated
              Company Website for its applicable privacy policy, which may differ from this one, depending on
              the specific nature of that Services and the transactions taking place there.  If an Affiliated
              Company Website has its own privacy policy, the provisions of that policy will control, to the
              extent of any conflict with this Privacy Policy.
            </p>
            <h4>EXTERNAL LINKS</h4>
            <p>
              For your convenience, we may provide links to websites that are external to us.  We do not
              operate these external websites, have no control over them and are not responsible for the
              privacy practices or contents of such external websites.  If you chose to visit any external
              website, understand that your use of such external website is subject to their terms of use
              and privacy practices.  Please familiarize yourself with their privacy policies and
              information collection practices.
            </p>
            <h4>CHANGES TO OUR PRIVACY POLICY</h4>
            <p>
              Our Privacy Policy may change at any time.  If there is a significant change in the information
              we collect or our other privacy practices, we will provide you notice through the Services or by
              another means.  Your continued access and use of the Services after we make changes is deemed to
              be acceptance of those changes, so please check our Privacy Policy periodically for
              updates.  Your access and use of the Services following the posting of any revised
              Privacy Policy will be deemed acceptance of the revised policy.
            </p>
            <h4>LOCATION OF OUR SERVERS</h4>
            <p>
              If you are visiting our Services from outside the United States, please be aware that our
              Services and the servers that host it are located in the United States and any information
              or data you provide, including personally identifiable information, will be transmitted to
              the United States and subject to access requests by U.S. authorities.
            </p>
            <h4>CONSENT</h4>
            <p>
              By accessing or using the Services or otherwise providing information to us, you consent
              to our collection and use of your information as described in this Privacy Policy.
            </p>
            <h4>GENERAL</h4>
            <p>
              This Privacy Policy is a part of our Terms and Conditions. The terms set forth in our Terms
              and Conditions, including your agreement with respect to the governing law and venue in the
              event of a dispute, apply to this Privacy Policy.
            </p>
            <h4>ENFORCEMENT OF THIS PRIVACY POLICY AND CONTACT INFORMATION</h4>
            <p>
              If you have questions or comments about this Privacy Policy or believe we have not adhered
              to this Privacy Policy, please contact our VP of Technical Operations at{' '}
              <a href='mailto:support@truckerpath.com'>support@truckerpath.com</a> or by mail at:
            </p>
            <p>
              <span className={cs(css.block)}>Trucker Path</span>
              <span className={cs(css.block)}>Re: Privacy Policy</span>
              <span className={cs(css.block)}>2828 N. Central Ave. 7th Floor</span>
              <span className={cs(css.block)}>Phoenix, AZ 85004</span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Privacy;



// WEBPACK FOOTER //
// ./src/components/pages/Privacy/index.js